import MoreIcon from "./images/icons/dots-horizontal-icon.svg?react";
import "./MoreButton.scss";

interface IMoreButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const MoreButton: React.FC<IMoreButtonProps> = ({
  onClick
}) => {
  return (
    <button onClick={(event) => onClick(event)} className="MoreButtonV2" title="Show more actions" aria-label="show more button">
      <MoreIcon />
    </button>
  );
};
